import WarningIcon from '../../images/Icon_Warning.png';

type Props = {
  message: string;
};

const ErrorMessage: React.FC<Props> = ({message}) => {
  return (
    <div className="InfoTableContainer">
      <div className="FailedMsg">
        <div className="MsgContainer Error">
          <div className="Img">
            <img src={WarningIcon} alt="Warning" />
          </div>
          <div className="Txt">{message}</div>
        </div>
      </div>
    </div>
  );
};

export default ErrorMessage;
